var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81138 16.6678C5.06278 16.8174 5.27862 17.0121 5.45087 17.2371H8.70604V14.0806L7.16253 13.1236C6.81876 12.9105 6.71286 12.459 6.92598 12.1153C7.13914 11.7716 7.59042 11.6657 7.93433 11.8787L9.43839 12.8112L10.7494 11.9984C8.13451 8.41283 8.73504 3.33221 12.2157 0.464604C6.48227 -1.45611 0.467845 2.8135 0.440699 8.94559C0.42654 12.1976 2.15787 15.0882 4.81138 16.6678Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90887 18.7018H12.8418V20.3618H5.90887V18.7018Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1707 14.0806V17.237H13.29C13.4557 17.0185 13.6623 16.8312 13.9027 16.6896C14.5684 16.2978 15.1795 15.8199 15.7211 15.273C14.1912 14.9285 12.8173 14.1677 11.7248 13.1163C11.6831 13.1434 11.3829 13.3291 10.1707 14.0806Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5777 0.00231934C13.7374 0.00231934 10.5959 3.1757 10.5959 7.03291C10.5959 10.6611 13.3811 13.6654 16.9522 13.9861C21.085 14.3553 24.5595 11.0793 24.5595 7.03291C24.5595 3.18317 21.4275 0.00231934 17.5777 0.00231934ZM18.311 10.2072V10.3603C18.311 10.7647 17.9831 11.0926 17.5787 11.0926C17.1742 11.0926 16.8463 10.7647 16.8463 10.3603V10.29C16.5089 10.2308 16.2006 10.1046 15.8112 9.84978C15.4727 9.62836 15.3778 9.1745 15.5992 8.83601C15.8207 8.49747 16.2746 8.40265 16.613 8.62402C16.97 8.85759 17.0857 8.8758 17.5737 8.87243C18.0449 8.86931 18.2326 8.49947 18.2693 8.28147C18.3022 8.08574 18.2652 7.82551 17.9022 7.69725C17.2942 7.48228 16.6707 7.23562 16.229 6.88917C15.2232 6.10028 15.5268 4.29845 16.8464 3.81895V3.71291C16.8464 3.30845 17.1743 2.98055 17.5787 2.98055C17.9832 2.98055 18.3111 3.30845 18.3111 3.71291V3.75353C18.6719 3.85537 18.9625 4.03959 19.1622 4.24259C19.4458 4.53095 19.4419 4.99462 19.1535 5.27824C18.8653 5.56171 18.402 5.55795 18.1184 5.27008C18.0775 5.2302 17.8519 5.04208 17.3635 5.18918C17.1685 5.24792 17.1161 5.45015 17.1047 5.51074C17.0808 5.63719 17.1148 5.72243 17.1329 5.73669C17.4092 5.95337 17.9236 6.15125 18.3904 6.31627C20.3206 6.99853 20.0855 9.56572 18.311 10.2072Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08063 22.7052C7.08063 23.9705 8.11002 24.9999 9.37533 24.9999C10.6406 24.9999 11.67 23.9705 11.67 22.7052V21.8264H7.08063V22.7052Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.be6870c71883ad796c493e3b6f1a9fef.svg";
export { ForwardRef as ReactComponent };